import { useEquipeTabela } from "./use-equipe-tabela";
import { EquipeTabelaView } from "./view-equipe-tabela";
import type { EquipeTabelaProps } from "./types-equipe-tabela";

export function EquipeTabela(props: EquipeTabelaProps) {
  const vm = useEquipeTabela(props);

  return <EquipeTabelaView {...props} {...vm} />;
}

export type * from "./types-equipe-tabela";
